import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
// import danger from "../icons/warning/danger.svg";
import home from "../icons/System/close.svg"
import error from "../icons/System/error.svg"
import info from "../icons/System/info.svg"
import { HeaderIconL } from "./HeaderGroup";
import { useFixedLayout } from "../../hooks/useFixedLayout";
import { formatRelativeTime } from "../../utils/formatTime";
import ListNoti from "./ListNoti";
import { HeaderTab } from "./HeaderTab";





const AdsAlarmList = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { storeBusinessNumber, fromTab, alarmTab } = location.state || {};

  const { headerRef, headerSpace, footerRef, bottomSpace } = useFixedLayout();
  const [eventNotices, setEventNotices] = useState([]);
  const [normalNotices, setNormalNotices] = useState([]);
  const [unreadNoticeNos, setUnreadNoticeNos] = useState([]);
  const [loading, setLoading] = useState(true);

  // 탭 상태: "event" / "normal"
  const [activeTab, setActiveTab] = useState(() => {
    if (alarmTab === "event" || alarmTab === "normal") {
      return alarmTab;
    }
    return "event";
  });

  // 30일 이내
  const isWithin30Days = (dateStr) => {
    if (!dateStr) return false;
    const d = new Date(dateStr);
    if (Number.isNaN(d.getTime())) return false;

    const now = new Date();
    const diffMs = now.getTime() - d.getTime();
    const DAY = 24 * 60 * 60 * 1000;

    // 미래 시간 제외 + 30일 이내만
    return diffMs >= 0 && diffMs < 31 * DAY;
  };

  useEffect(() => {
    const fetchNotices = async () => {
      try {
        const userId = localStorage.getItem("user_id");

        const [noticeRes, readRes] = await Promise.all([
          axios.get(
            `${process.env.REACT_APP_FASTAPI_ADS_URL}/ads/get/notice`,
            { params: {} }
          ),
          axios.get(
            `${process.env.REACT_APP_FASTAPI_ADS_URL}/ads/get/notice/check/read`,
            { params: { user_id: userId } }
          ),
        ]);

        const list = noticeRes.data || [];

        const events = [];
        const normals = [];

        list.forEach((n) => {
          const rawType = (n.notice_type || "").toString().trim();
          const type = rawType === "이벤트" ? "이벤트" : "일반";

          const createdAt = n.created_at; // 날짜 컬럼

          if (type === "이벤트") {
            if (isWithin30Days(createdAt)) {
              events.push(n);
            }
          } else {
            normals.push(n);
          }
        });

        // 이벤트: created_at 기준 최신순 정렬
        const sortedEvents = [...events].sort((a, b) => {
          const da = new Date(a.created_at).getTime() || 0;
          const db = new Date(b.created_at).getTime() || 0;
          return db - da; // 최신 먼저
        });

        // 공지사항: created_at 기준 최신순 정렬
        const sortedNormals = [...normals].sort((a, b) => {
          const da = new Date(a.created_at).getTime() || 0;
          const db = new Date(b.created_at).getTime() || 0;
          return db - da; // 최신 먼저
        });

        setEventNotices(sortedEvents);   // 최근 30일
        setNormalNotices(sortedNormals); // 최신 3개만
        // setEventNotices(events);
        // setNormalNotices(normals);

        // 읽지 않은 notice 번호들
        const unreadIds = (readRes.data?.unread_notices ?? []).map((n) =>
          Number(n.notice_no ?? n)
        );
        setUnreadNoticeNos(unreadIds);
      } catch (e) {
        console.error("알림 목록 로딩 실패:", e);
      } finally {
        setLoading(false);
      }
    };

    fetchNotices();
  }, []);

  const handleClickNotice = async (notice) => {
    const userId = localStorage.getItem("user_id");

    // 🔹 로컬 상태에서 읽지 않은 목록에서 제거
    setUnreadNoticeNos((prev) =>
      prev.filter((id) => id !== Number(notice.notice_no))
    );

    // 🔹 서버에도 읽음 처리
    try {
      await axios.post(
        `${process.env.REACT_APP_FASTAPI_ADS_URL}/ads/notice/read`,
        {
          user_id: userId,
          notice_no: notice.notice_no,
        }
      );
    } catch (e) {
      console.error("읽음 처리 실패:", e);
    }

    navigate(`/ads/notice/${notice.notice_no}`, {
      state: { notice, storeBusinessNumber, fromTab, source: "alarm" },
    });
  };

  const returnHome = () => {
    navigate("/ads/main", { state: { storeBusinessNumber } });
  }

  // 안 읽은 것 있는지 체크
  const hasUnreadEvent = eventNotices.some((n) =>
    unreadNoticeNos.includes(Number(n.notice_no))
  );
  const hasUnreadNormal = normalNotices.some((n) =>
    unreadNoticeNos.includes(Number(n.notice_no))
  );

  const tabs = [
    { key: "event", label: "이벤트 알림", hasIcon: hasUnreadEvent },
    { key: "normal", label: "공지사항", hasIcon: hasUnreadNormal },
  ];

  const isEventTab = activeTab === "event";
  const showEventInfo = isEventTab && eventNotices.length > 0;


  if (loading) {
    return (
      <div className="flex flex-col h-dvh bg-bg-white">
        <div
          ref={headerRef}
          className="fixed top-0 left-0 right-0 z-10"
        >
          <HeaderIconL className=""
            title="알림"
            icon={home}
            onIconClick={returnHome}
          />
          <HeaderTab
            tabs={tabs}
            activeTab={activeTab}
            onChange={setActiveTab}
          />
        </div>
      </div>
    );
  }


  return (
    <div className="flex flex-col h-dvh bg-surface-light-white">
      {/* 상단 헤더 */}
      <div ref={headerRef} className="fixed top-0 left-0 right-0 z-10">
        <HeaderIconL className=""
          title="알림"
          icon={home}
          onIconClick={returnHome}
        />
        <HeaderTab
          tabs={tabs}
          activeTab={activeTab}
          onChange={setActiveTab}
        />
      </div>

      <div
        className="flex-1 overflow-y-auto"
        style={{
          paddingTop: headerSpace,
          paddingBottom: showEventInfo ? bottomSpace : 0,
        }}
      >
        {isEventTab ? (
          <>
            {eventNotices.length > 0 ? (
              <ul className="space-y-[8px] py-[20px] px-[16px]">
                {eventNotices.map((notice) => {
                  const isUnread = unreadNoticeNos.includes(
                    Number(notice.notice_no)
                  ); // 읽음 여부
                  return (
                    <ListNoti
                      key={notice.notice_no}
                      notice={notice}
                      isUnread={isUnread}
                      onClick={handleClickNotice}
                      formatRelativeTime={formatRelativeTime}
                    />
                  );
                })}
              </ul>
            ) : (
              <div className="flex h-full items-center justify-center">
                <div className="flex flex-col items-center transform translate-y-[-5vh]">
                  <img src={error} alt="error" />

                  <p className="text-b2 text-text-subtler text-center pt-[16px]">
                    최근 30일동안
                    <br />
                    받은 알림이 없어요
                  </p>
                </div>
              </div>
            )}
          </>
        ) : (
          <>
            {normalNotices.length > 0 ? (
              <ul className="space-y-[8px] py-[20px] px-[16px]">
                {normalNotices.map((notice) => {
                  const isUnread = unreadNoticeNos.includes(
                    Number(notice.notice_no)
                  ); //읽음 여부
                  return (
                    <ListNoti
                      key={notice.notice_no}
                      notice={notice}
                      isUnread={isUnread}
                      onClick={handleClickNotice}
                      formatRelativeTime={formatRelativeTime}
                    />
                  );
                })}
              </ul>
            ) : (
              <div className="flex h-full items-center justify-center">
                <div className="flex flex-col items-center transform translate-y-[-5vh]">
                  <img src={error} alt="error" />
                  <p className="text-b2 text-text-subtler text-center pt-[16px]">
                    공지사항이 없어요
                  </p>
                </div>
              </div>
            )}
          </>
        )}
      </div>

      {showEventInfo && (
        <div
          ref={footerRef}
          className="fixed left-0 right-0 bottom-0 z-10 px-[16px] py-[21px] bg-surface-light-white">
          <div className="flex items-center justify-center gap-[4px]">
            <img src={info} alt="" className="w-[20px] h-[20px]" />
            <p className="text-c1 text-text-subtler">
              30일 전 알림까지 확인할 수 있어요
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdsAlarmList;
